import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { Trans } from "@coworker/locales";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";

export const SearchResultsTitle = () => {
  return (
    <FixaListView id={"search-results-title"} size={"small"}>
      <FixaListViewItem
        title={<Trans>searchResultsString</Trans>}
        inset
        emphasised
      />
    </FixaListView>
  );
};
